import { formatarMoeda } from "../../Detalhe/utils/agregarPorConta.util";

export function formatarDataBr(iso) {
  if (!iso || String(iso).length < 10) return "—";
  const p = String(iso).slice(0, 10).split("-");
  if (p.length !== 3) return String(iso);
  return `${p[2]}/${p[1]}/${p[0]}`;
}

export function formatarSelicPct(valor) {
  if (valor == null || valor === "") return "—";
  const n = Number(valor);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 4,
  })}%`;
}

/**
 * @param {object} col
 * @param {Record<string, unknown>} row
 */
export function formatarCelulaLancamento(col, row) {
  const v = row[col.id];
  if (v == null || v === "") return "—";
  if (col.cell === "date") return formatarDataBr(v);
  if (col.cell === "money") return formatarMoeda(v);
  if (col.cell === "selic") return formatarSelicPct(v);
  if (col.cell === "year") return String(v);
  return String(v);
}

/**
 * @param {object} filtrosUi
 */
export function filtrosUiParaQuery(filtrosUi = {}) {
  const params = {};
  const keys = [
    "competenciaInicio",
    "competenciaFim",
    "buscaConta",
    "compoeProjeto",
    "pisMin",
    "pisMax",
    "cofinsMin",
    "cofinsMax",
  ];
  for (const key of keys) {
    const v = filtrosUi[key];
    if (v != null && String(v).trim() !== "") params[key] = String(v).trim();
  }
  if (Array.isArray(filtrosUi.contasSelecionadas) && filtrosUi.contasSelecionadas.length) {
    params.contasSelecionadas = filtrosUi.contasSelecionadas.join(",");
  }
  return params;
}
